import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectProviderUploadComplete, selectProviderUploadLoading } from '@store/selectors/clinician-details/clinician-details.selectors';
import { ClinicianDetailsActions } from '@store/actions/clinician-details/clinician-details.actions';
import { ProviderUploadComponent } from "../../provider-upload/provider-upload.component";

@Component({
  selector: 'app-provider-upload-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    ProviderUploadComponent
  ],
  templateUrl: './provider-upload-modal.component.html',
  styleUrl: './provider-upload-modal.component.css'
})
export class ProviderUploadModalComponent {
  uploadComplete$: Observable<boolean>;
  uploadLoading$: Observable<boolean>;

  constructor(
    private dialogRef: MatDialogRef<ProviderUploadModalComponent>,
    private store: Store,
    @Inject(MAT_DIALOG_DATA) public data: { organizationId: string }
  ) {
    this.uploadComplete$ = this.store.select(selectProviderUploadComplete);
    this.uploadLoading$ = this.store.select(selectProviderUploadLoading);
  }

  close(result?: boolean): void {
    this.store.dispatch(ClinicianDetailsActions.clearProviderUploadState());
    this.dialogRef.close(result);
  }
}
